import { call, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";

export default function* dashboardFetch(action: ActionInterface): any {
  try {

    const res = yield call(Http.get, "dashboard");

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res.data.units);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchDashboardFetch() {
  yield takeEvery(Constants.DASHBOARD_FETCH, dashboardFetch);
}
